import { render, staticRenderFns } from "./TravelPackage.vue?vue&type=template&id=82018bcc&scoped=true"
import script from "./TravelPackage.vue?vue&type=script&lang=js"
export * from "./TravelPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82018bcc",
  null
  
)

export default component.exports